import * as schemas from './schemas';

export const createSession = /* GraphQL */ `
  mutation CreateSession(
    $input: CreateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    createSession(input: $input, condition: $condition) {
      ${schemas.sessionSchema}
    }
  }
`;
export const updateSession = /* GraphQL */ `
  mutation UpdateSession(
    $input: UpdateSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    updateSession(input: $input, condition: $condition) {
      ${schemas.sessionSchema}
    }
  }
`;
export const deleteSession = /* GraphQL */ `
  mutation DeleteSession(
    $input: DeleteSessionInput!
    $condition: ModelSessionConditionInput
  ) {
    deleteSession(input: $input, condition: $condition) {
      ${schemas.sessionSchema}
    }
  }
`;

export const createPreReservedParticipant = /* GraphQL */ `
  mutation createPreReservedParticipant(
    $input: CreatePreReservedParticipantInput!
    $condition: ModelPreReservedParticipantConditionInput
  ) {
    createPreReservedParticipant(input: $input, condition: $condition) {
      ${schemas.sessionSchema}
    }
  }
`;

export const deletePreReservedParticipant = /* GraphQL */ `
  mutation deletePreReservedParticipant(
    $input: DeletePreReservedParticipantInput!
    $condition: ModelPreReservedParticipantConditionInput
  ) {
    deletePreReservedParticipant(input: $input, condition: $condition) {
      ${schemas.sessionSchema}
    }
  }
`;

export const removePreReservations = /* GraphQL */ `
  mutation removePreReservations(
    $participants: [PreReservadParticipant]!
  ) {
    removePreReservations(participants: $participants) {
      ${schemas.mutationResult}
    }
  }
`;

export const updatePreReservedParticipant = /* GraphQL */ `
  mutation updatePreReservedParticipant(
    $input: UpdatePreReservedParticipantInput!
    $condition: ModelPreReservedParticipantConditionInput
  ) {
    updatePreReservedParticipant(input: $input, condition: $condition) {
      ${schemas.preReservedParticipantSchema}
    }
  }
`;

export const handleUpdateReplicaSessions = `
  mutation handleUpdateReplicaSessions($input: TransactionInput!, $workspace: Workspaces!, $recurringUuid: String){
    handleUpdateReplicaSessions(input: $input, workspace: $workspace, recurringUuid: $recurringUuid) {
      create{
        ${schemas.sessionSchema}
      }
      edit{
        ${schemas.sessionSchema}
      }
      delete{
        ${schemas.sessionSchema}
      }
      workspace
    }
  }
`;
